/* @ngInject */
function CampaignMaterialActionsAssetCardController ($scope, TemplateService, AssetPreviewService, ArtCollectionsService) {
  const api = {
    _sanitizeMaterial,
    _getTemplateThumbUrl,
    _getFolderThumbUrl
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._sanitizeMaterial()
  }

  $scope.removeSelectedMaterial = () => {
    const index = $scope.selectedMaterials.findIndex(material => material.id === $scope.material.id)
    if (index > -1) {
      $scope.selectedMaterials.splice(index, 1)
    }
  }

  function _sanitizeMaterial () {
    const isTemplate = 'isTemplate' in $scope.material

    if (isTemplate) {
      $scope.material = {
        ...$scope.material,
        name: $scope.material.name.length > 10 ? $scope.material.name.substring(0, 10) + '...' : $scope.material.name,
        backgroundImage: api._getTemplateThumbUrl($scope.material),
        type: 'TEMPLATE'
      }
    } else {
      $scope.material = {
        ...$scope.material,
        name: $scope.material.title.length > 10 ? $scope.material.title.substring(0, 10) + '...' : $scope.material.title,
        backgroundImage: api._getFolderThumbUrl($scope.material),
        type: 'FOLDER'
      }
    }
  }

  function _getTemplateThumbUrl (material) {
    const types = ['IMAGE', 'PDF', 'VIDEO']
    if (types.includes(material.asset?.type) || material.thumbnailContentType || material.isCustomizable) {
      return AssetPreviewService.getArtPreview(material.id)
    }

    $scope.defaultThumb = true
    return TemplateService.getDefaultThumbnail(material.asset?.files[0]?.extension)
  }

  function _getFolderThumbUrl (material) {
    if (!material.thumbnailContentType) {
      return '/assets/img/campaigns/action-collection-thumbnail.png'
    }

    return ArtCollectionsService.getArtCollectionThumbnail(material.id, material.updatedAt)
  }
}

export { CampaignMaterialActionsAssetCardController }
